import { STATIC_CONTENT_TYPE_NAMES } from '@bm-js/atlascloud-shared'
import { useEditorActions, useEditorData } from '../../utils/hooks'
import Breadcrumbs from '../Breadcrumbs'

const EditorBreadcrumbs = () => {
  const { activePage, breadcrumbs, workingConfig } = useEditorData()
  const { setActivePage } = useEditorActions()

  if (
    !activePage ||
    STATIC_CONTENT_TYPE_NAMES.includes(activePage.content[0]?.name) ||
    !breadcrumbs.length
  ) {
    return null
  }

  return (
    <Breadcrumbs
      paths={breadcrumbs}
      setActivePageFromNav={(p) => setActivePage(p.uuid)}
      websiteConfig={workingConfig}
    />
  )
}

export default EditorBreadcrumbs
